import React from 'react';
import { useTranslation } from 'react-i18next';
import BzmIcon from '../../../components/icons/BzmIcon';

const BlueprintEmptyState = () => {
  const { t } = useTranslation('blueprints');
  return (
    <div className="text-center p-5">
      <BzmIcon variant="icon-bzm-template" size={64} color="#c2c8d2" />
      <h4 className="mt-3">{t('empty.title')}</h4>
      <p className="text-muted">{t('empty.body')}</p>
    </div>
  );
};

export default BlueprintEmptyState;
